import * as S from './Headline.styles';
import { TextProps } from './Headline.styles';

export type HeadlineProps = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  children: React.ReactNode;
  className?: string;
} & TextProps;

const defaultProps: Partial<HeadlineProps> = {
  tag: 'p',
  className: '',
  scale: 's',
  fontFamily: 'LFT Zeno',
};

export function Headline(props: HeadlineProps): React.ReactElement {
  const {
    tag,
    children,
    scale,
    className,
    color,
    fontWeight,
    textTransform,
    textAlign,
    fontFamily,
  } = {
    ...defaultProps,
    ...props,
  };

  return (
    <S.Text
      className={className}
      fontWeight={fontWeight}
      color={color}
      scale={scale}
      as={tag}
      textTransform={textTransform}
      textAlign={textAlign}
      fontFamily={fontFamily}
    >
      {children}
    </S.Text>
  );
}
